import _ from 'underscore';
import xtend from 'xtend';
import EVS from '../../EVENTS';
var sub = {
    req: require('../lib/request')
};

function ChatSubscription (bus, api, store) {

    // this is when you first enable chat for an event
    // we update the event object, then create the mod
    bus.on('chat.enableChatWithModerator', function (ev) {
        bus
            .once(EVS.http.events.edit.start, function (_ev) {
                store.requests.chat.start(_ev);
            })
            .once(EVS.http.events.edit.resolve, function (_ev) {
                console.log('chat enable with moderator:', _ev, ev)
                store.requests.chat.resolve(_ev);
                api.chat.createModerator(xtend(ev.moderator, {
                    eventID: ev.eventID
                }));
            })
            .once(EVS.http.events.edit.error, function (_ev) {
                store.requests.chat.error(_ev);
            });

        api.events.edit({
            eventID: ev.eventID,
            chat: ev.chat
        });
    });

    bus.on('chat.updateChatSettings', function (ev) {
        const request = {
            data: {
                type: 'updateChatSettings',
                action: 'crud',
                settings: ev.settings,
                eventId: ev.eventId,
                clientId: ev.clientId
            }
        }
        api.chat.updateChatSettings(request)
    })

    // -------- view events & http effects --------
    bus.on('chat.createModerator', function (ev) {
        // if chat isn't already, enable it
        if (!ev.chatIsEnabled) return api.chat.createModerator(ev);

        bus
            .once(EVS.http.events.edit.start, function (_ev) {
                store.requests.chat.start(_ev);
            })
            .once(EVS.http.events.edit.resolve, function (_ev) {
                store.requests.chat.resolve(_ev);
                api.chat.createModerator(ev);
            })
            .once(EVS.http.events.edit.error, function (_ev) {
                store.requests.chat.error(_ev);
            });

        api.events.edit({
            eventID: ev.data.eventId,
            chat: {
                chatTypeID: 2,
                enabled: true,
                isLoginEnabled: false,
                loginPass: null
            }
        });
    });

    bus.on('chat.getModerators', function (ev) {
        api.chat.getModerators(ev);
    });

    bus.on('chat.deleteModerator', function (ev) {
        api.chat.deleteModerator(ev);
    });

    bus.on('chat.resetPassword', function (ev) {
        api.chat.resetPassword(ev);
    });

    // ----------------------------------------------

    httpUpdate(EVS.http.chat, bus, store);
}

function httpUpdate (evs, bus, store) {
    bus.on(evs.createModerator.resolve, function (ev) {
        store.chat.add(xtend({name:ev.req.data.moderator.name, email:ev.req.data.moderator.email}, {
            eventID: parseEventID(ev.req.data.eventId)
        }));
    });

    bus.on(evs.deleteModerator.resolve, function (ev) {
        store.chat.delete(xtend(ev.res, {
            eventID: parseEventID(ev.req.data.eventId)
        }));
    });

    bus.on(evs.getModerators.resolve, function (ev) {
        store.chat.set(ev.res.map(mod => xtend(mod, {
            eventID: ev.req.data.eventId
        })));
    });

    bus.on(evs.resetPassword.resolve, function (ev) {
        store.messages.push({
            type: 'success',
            message: 'Reset 1 password'
        })
    });

    sub.req(store.requests.chat, bus, { evs: evs.createModerator });
    sub.req(store.requests.chat, bus, { evs: evs.getModerators });
    sub.req(store.requests.chat, bus, { evs: evs.deleteModerator });
    sub.req(store.requests.chat, bus, { evs: evs.resetPassword });
}

export default ChatSubscription;

function parseEventID (id) {
    return _.last(id.split('_'));
}
